export default __webpack_public_path__ + "static/media/mesh_dt.56aeffd7.png";